
const BASE_API_URL = `${
  process.env.NODE_ENV !== 'production'
    ? 'http://backend:8000'
    : process.env.NEXT_PUBLIC_DJANGO_URL
}/api`;

export default BASE_API_URL;
